// extracted by mini-css-extract-plugin
module.exports = {"schoolEditBtnWrap":"style_schoolEditBtnWrap__13DeD","schoolEditBtn":"style_schoolEditBtn__2OWo1"};